/*
 * @Author: xinxin 18617269361@163.com
 * @Date: 2025-04-17 10:44:31
 * @LastEditors: xinxin 18617269361@163.com
 * @LastEditTime: 2025-06-05 17:30:03
 * @FilePath: \lhao-pc\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";

// import "@/utils/flexible";
import "lib-flexible-computer";
import ElementPlus from "element-plus"; //全局引入
import "element-plus/dist/index.css";
import "@/static/font/font.css";
createApp(App).use(store).use(router).use(ElementPlus).mount("#app");
